<!-- class="form-control form-control-sm w-auto pr-4"-->
<div *ngIf="(ie.TypeDID == IE_TYPES.LanguageSelector)">
    <select id="languageOption" 
            (change)="fetchIEUserAction(ie.Attributes.OnClickUAID, ieLangOption.value, null, null, null, null, null)"
            class="form-select form-select-sm" 
            type="text"  
            #ieLangOption>
      <option *ngFor="let lo of languageOptions" [value]="lo.key"
      [selected]="lo.key == selectedLanguageCodeID? true: null" >
        {{lo.value}}
      </option>
      </select>
</div>

<div *ngIf="( ie.TypeDID == IE_TYPES.InputPicklist && formgroup != null )" [formGroup]="formgroup">
  
  <ng-container *ngIf="(ie.CustomizeOptions != null  && ie.CustomizeOptions.DisplayType == 'flexbox'); else defaultPicklist">
    <app-cosy-flexbox [ie]="ie" [entityFormGroup]="formgroup"></app-cosy-flexbox>
  </ng-container>
  <ng-template #defaultPicklist>
   <input type="hidden" [formControlName] = "ie.InterfaceElementID">
   <!--<fieldset  [disabled]="(formgroup!= null)? ie.FormControlProperties.Disabled: !ie.Attributes.Enabled" 
     class="listMultiSelectContainer mb-2" [style]="ie.CustomizeOptions.Size" *ngIf="ie.CustomizeOptions != null&& ie.CustomizeOptions.Multiple !=null">-->
     <fieldset  
     class="listMultiSelectContainer mb-2" [style]="ie.CustomizeOptions.Size" *ngIf="ie.CustomizeOptions != null&& ie.CustomizeOptions.Multiple !=null">
     <input type="hidden" [formControlName]="">
     <ul class="list-group ">
        <li *ngIf="listOptions.length>0"  class="list-group-item" style="height:25px; padding: 0px 4px; border:0px;">
          <span class="multiSelectOptionClass">
          <input #cb type="checkbox" id="selectAll" [checked]="getAllSelectedOption(ie.Values, cb.checked)" (change)="onAllOptionSelect(cb.checked)" [formControlName]="ie.InterfaceElementID+'_alle'"/>
            <p class="multiSelectTextAllign">{{selectAllTextShort}}</p>
            </span>
          </li>
        <li *ngFor="let entityIEOpt of listOptions" class="list-group-item" style="height:25px; padding: 0px 4px; border:0px;">
          <span class="multiSelectOptionClass">
           <input #cb type="checkbox" [id]="entityIEOpt.key"  [checked]="getSelectedOption(ie.Values, entityIEOpt.key)" (change)="onOptionSelect(entityIEOpt,cb.checked)"  [formControlName]="entityIEOpt.key"/>
            <p class="multiSelectTextAllign">{{entityIEOpt.value}}</p>
          </span>
        </li>
     </ul>
    </fieldset>
    

    
    <div *ngIf="ie.CustomizeOptions == null" class="input-group input-group-sm mb-2">
      <select *ngIf="ie.CustomizeOptions == null"
      class="form-select form-select-sm" 
      (change)="fetchIEUserAction(ie.Attributes.OnSelectUAID, ieoption.value, null, null, null, formgroup, null)"
      [formControlName]="ie.InterfaceElementID"
      #ieoption>    
      <option *ngFor="let entityIEOpt of listOptions" [value]="entityIEOpt.key" 
      [selected]="entityIEOpt.key == ieValue? true: null">
      {{entityIEOpt.value}}</option>
    </select>
    <span *ngIf="ie.Attributes.Required" class="input-group-text cosyColorRequired">*</span>
    
  </div>
</ng-template>
</div>

<div *ngIf="( ie.TypeDID == IE_TYPES.InputPicklist && formgroup == null)" >
  <ng-container *ngIf="(ie.CustomizeOptions != null  && ie.CustomizeOptions.DisplayType == 'flexbox' ); else defaultAuto">
    <app-cosy-flexbox [ie]="ie" [entityFormGroup]=null></app-cosy-flexbox>
  </ng-container>
  <ng-template #defaultAuto>
  <!--<nav class="breadcrumb nav-background rounded-0 pt-2 pb-3 pl-n2 uxStyle">-->
   
    <select 
      class="form-select form-select-sm" 
      (change)="fetchIEUserAction(ie.Attributes.OnSelectUAID, ieoption.value, null, null, null, formgroup, null,$event)"
      [(ngModel)]="values"
      #ieoption>    
      <option *ngFor="let option of listOptions" [value]="option.key" 
      [selected]="option.key == ieValue? true: null">
      {{option.value}}</option>
    </select>
 </ng-template>
</div>
<!--form-control form-control-sm w-auto pl-1
 class="form-control form-control-sm w-auto p-0" -->
<div *ngIf="( ie.TypeDID == IE_TYPES.InputValuePicklist && formgroup == null)" >
  <select
    class="form-select form-select-sm" 
    (change)="fetchIEUserAction(ie.Attributes.OnSelectUAID, ieoption.value, null, null, null, formgroup, null,$event)"  
    [(ngModel)]="values"
    #ieoption>    
    <option *ngFor="let option of listOptions" [value]="option.value" 
    [selected]="option.key == ieInputKey? true: null">
    {{option.value}}
    </option>
  </select>
</div>




